// @flow
import { handleResponseOld, makeGet, makePost } from './helpers';

type FetchConversationMessagesParams = {
    authToken: string,
    bidderId: number,
    conversationId: number,
    deployment: string,
};

type SendConversationMessageParams = {
    attachedFiles: any[],
    authToken: string,
    bidderId: number,
    conversationId: number,
    deployment: string,
    messageBody: any,
};

export default {
    fetchConversationMessages: ({ authToken, bidderId, conversationId, deployment }: FetchConversationMessagesParams) =>
        new Promise<any>((resolve, reject) => {
            /**
             * TODO: get real data from api, return mocked data for now
             */
            // if (true) {
            //     const messages = [...new Array(15)]
            //         .map((_, i) => {
            //             const authorId = Math.floor(Math.random() * 2) + 1;
            //             const authorName = `user-${authorId}`;
            //             const body =
            //                 Math.random()
            //                     .toString(36)
            //                     .substring(2, 15) +
            //                 Math.random()
            //                     .toString(36)
            //                     .substring(2, 15);

            //             const dateCreatedTs = (d => new Date(d.setDate(d.getDate() - 15 + i * Math.random())))(
            //                 new Date()
            //             );

            //             return {
            //                 attachments: [
            //                     {
            //                         url:
            //                             'https://s3.amazonaws.com/attachments.liveauctioneers.com/attachments/bbf38d0492f0f83cdbe0fa389852cb3a.jpg',
            //                     },
            //                     {
            //                         url:
            //                             'https://s3.amazonaws.com/attachments.liveauctioneers.com/attachments/fileName2',
            //                     },
            //                     {
            //                         url:
            //                             'https://s3.amazonaws.com/attachments.liveauctioneers.com/attachments/fileName3',
            //                     },
            //                 ],
            //                 conversationId,
            //                 messageBody: body,
            //                 messageId: Math.floor(Math.random() * 90000000) + 10000000,
            //                 sender: {
            //                     id: authorId,
            //                     name: authorName,
            //                     type: 'bidder',
            //                 },
            //                 tsSent: dateCreatedTs,
            //             };
            //         })
            //         .sort((a, b) => a.tsSent - b.tsSent);

            //     return resolve({
            //         data: {
            //             messages,
            //         },
            //     });
            // }

            const request = makeGet({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/messages`,
            });
            request.query({ conversationId });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    sendConversationMessage: ({
        attachedFiles = [],
        authToken,
        bidderId,
        conversationId,
        deployment,
        messageBody,
    }: SendConversationMessageParams) =>
        new Promise<any>((resolve, reject) => {
            /**
             * TODO: get real data from api, return mocked data for now
             */
            // if (true) {
            //     return resolve({
            //         data: {
            //             error: false,
            //             meta: {},
            //             payload: [
            //                 {
            //                     attachments: [
            //                         {
            //                             url:
            //                                 'https://s3.amazonaws.com/attachments.liveauctioneers.com/attachments/bbf38d0492f0f83cdbe0fa389852cb3a.jpg',
            //                         },
            //                         {
            //                             url:
            //                                 'https://s3.amazonaws.com/attachments.liveauctioneers.com/attachments/fileName2',
            //                         },
            //                         {
            //                             url:
            //                                 'https://s3.amazonaws.com/attachments.liveauctioneers.com/attachments/fileName3',
            //                         },
            //                     ],
            //                     conversationId: Math.floor(Math.random() * 90000000) + 10000000,
            //                     messageBody,
            //                     messageId: Math.floor(Math.random() * 90000000) + 10000000,
            //                     sender: {
            //                         id: 1391153,
            //                         name: 'user-1',
            //                         type: 'bidder',
            //                     },
            //                     tsSent: new Date().getTime(),
            //                 },
            //             ],
            //         },
            //     });
            // }

            const request = makePost({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/messages`,
            });
            attachedFiles.forEach(file => {
                request.attach(file.name, file);
            });
            request.query({ bidderId, conversationId, messageBody });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
